import { useState, useEffect, useContext } from "react";
import { Row, Col, Button, Form, Alert, Modal, ProgressBar, Card, Nav, Table } from "react-bootstrap";

import _, { setWith } from "lodash";
import axios from "axios";
import moment from "moment";
import Utils from "../../common/Utils";
import { UserContext } from "../../common";

const MyProfile = (props) => {
  const { userData } = useContext(UserContext);
  const [data, setData] = useState({});
  const [udocs, setUDocs] = useState({ doctypes: [], userdocs: [], userdocfiles: [], counts: [], udgs: {} });
  const [loading, setLoading] = useState(true);
  const [dtype, setDType] = useState(0);
  const [resources, setResources] = useState(false);
  const [upload, setUpload] = useState(false);
  const [trail, setTrail] = useState(false);
  const [cal, setCal] = useState(false);
  const [loadres, setLoadres] = useState(false);
  const [showprof, setShowprof] = useState(true);
  const [gapStatus, setGapStatus] = useState(0);
  const [sall, setsall] = useState(0);
  const [udNote, showUDNote] = useState(false);
  const [notes, setNotes] = useState([]);
  const [uploading, setUploading] = useState(false);

  const profileDetails = (status = 0) => {
    setLoading(true);
    status === 0 ? setShowprof(true) : setShowprof(false);
    axios
      .get(Utils.apiUrl("users/fetchprofile") + `?status=${status}&gapStatus=${gapStatus}`, Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setData(_.get(res, "data.profile", []));
          setUDocs({
            doctypes: _.get(res, "data.doctypes", []),
            userdocs: _.get(res, "data.userdocs", []),
            userdocfiles: _.get(res, "data.userdocfiles", []),
            counts: _.get(res, "data.counts", []),
            udgs: _.get(res, "data.udgs", []),
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(true);
        console.log(err);
      });
  };

  useEffect(profileDetails, []);

  const fetchUDNotes = () => {
    if (udNote !== false && _.isUndefined(udNote.loading)) {
      showUDNote({ ...udNote, loading: true });
      axios
        .get(Utils.apiUrl(`users/fetchnotes?uid=${userData.uid}&udid=${udNote.id}`), Utils.apiHeaders())
        .then((res) => {
          showUDNote({ ...udNote, loading: false });
          if (res.data.success) {
            setNotes(res.data.data);
          } else {
            window.alert(res.data.message);
          }
        })
        .catch((err) => console.log(err));
    }
  };
  
  useEffect(fetchUDNotes, [udNote]);

  const saveProfile = (e) => {
    const frm = e.currentTarget;
    e.preventDefault();

    let pvals = {
      firstname: frm.firstname,
      middlename: frm.middlename,
      lastname: frm.lastname,
      phone: frm.phone,
      email: frm.email,
      gdc: frm.gdc,
      doj: frm.doj,
      dob: frm.dob,
      lwd: frm.lwd,
      gender: frm.gender,
      title: frm.title,
      designation: frm.designation,
      pronoun: frm.pronoun,
      notes: frm.notes,
      relship1: frm.relship1,
      name1: frm.name1,
      address1: frm.address1,
      phone1: frm.phone1,
      relship2: frm.relship2,
      name2: frm.name2,
      address2: frm.address2,
      phone2: frm.phone2,
      acnum: frm.acnum,
      ifsc: frm.ifsc,
      bank: frm.bank,
      branch: frm.branch,
    };

    _.each(pvals, validateField);

    let haserror = false;

    //== extra check for date range
    if (pvals.doj.value != "" && pvals.lwd.value != "" && moment(pvals.doj.value).isAfter(moment(pvals.lwd.value))) {
      pvals.lwd.className = "form-control invalid";
      pvals.lwd.focus();
      return false;
    } else {
      pvals.lwd.className = "form-control valid";
    }

    haserror = _.flatten(_.map(pvals, (field) => (field.className.includes("invalid") ? 1 : 0))).includes(1);
    if (haserror) {
      _.each(pvals, (field) => {
        if (field.className.includes("invalid")) {
          field.focus();
          return false;
        } else {
          return true;
        }
      });
      return false;
    }

    _.each(pvals, (v, k) => (pvals[k] = v.value));

    setData(pvals);
    setLoading(true);
    axios
      .post(Utils.apiUrl("users/saveprofile"), Utils.postVars(pvals), Utils.apiHeaders())
      .then((res) => {
        setLoading(false);
        if (res.data.success) {
          //props.onAdd();
          setData(_.get(res, "data.profile", {}));
        } else {
          window.alert(_.isObject(res.data.message) ? Object.values(res.data.message).join(",") : res.data.message);
        }
      })
      .catch((err) => console.log(err));
  };

  const showStatus = (data) => {
    if (data.exp_status == 0) {
      if (data.doc_status == 1) {
        return <span className="text-success">Approved</span>;
      } else if (data.doc_status == 2) {
        return <span className="text-warning">Pending</span>;
      } else if (data.doc_status == 3) {
        return (
          <span className="text-danger" title={data.msg ?? ""}>
            Disapproved {data.msg && <i class="bi bi-chat-left-dots"></i>}
          </span>
        );
      }
    } else {
      return <span className="text-danger">Expired</span>;
    }
  };

  const uploadFile = (e) => {
    const frm = e.currentTarget;
    e.preventDefault();
    setUploading(true);
    setLoadres(parseInt(frm.udid.value));

    let formData = new FormData(frm);
    formData.append("time", new moment().format("YYYY-MM-DD HH:mm:ss"));

    axios
      .post(Utils.apiUrl("users/uploadudf"), formData, Utils.apiHeaders())
      .then((res) => {
        setUploading(false);
        setLoadres(false);
        if (res.data.success) {
          setUDocs((prev) => ({
            ...prev,
            userdocfiles: [...prev.userdocfiles.filter((f) => f.id !== res.data.udf.id), res.data.udf],
          }));
          profileDetails(showprof ? 0 : 1);
          frm.reset();
        } else {
          window.alert(_.isObject(res.data.message) ? Object.values(res.data.message).join(",") : res.data.message);
        }
      })
      .catch((err) => {
        setUploading(false);
        setLoadres(false);
        console.log(err);
      });
  };

  const validateMe = (e) => {
    const field = e.currentTarget;
    validateField(field);
  };

  const validateField = (field) => {
    if (field.hasAttribute("regex")) {
      const regex = new RegExp("^" + field.getAttribute("regex") + "$", "i");
      if (regex.test(field.value)) {
        field.className = "form-control valid";
      } else {
        field.className = "form-control invalid";
      }
    }
  };

  const renderForm = () => {
    return (
      <Form className="needs-validation" novalidate onSubmit={saveProfile}>
        <Row>
          <Col sz={2} xl={2} lg={2} md={6} className="mb-1">
            <label className="form-label">Title *</label>
            <select className="form-select" name="title" required defaultValue={_.get(data, "title", "")}>
              {["Mr.", "Mrs.", "Ms.", "Dr.", "Prefer not to say"].map((t) => (
                <option value={t}>{t}</option>
              ))}
            </select>
            <div className="invalid-feedback">Please Select Title of User</div>
          </Col>
          <Col sz={6} xl={4} lg={5} md={6} className="mb-1">
            <label className="form-label">First Name *</label>
            <input
              type="text"
              name="firstname"
              required
              maxlength="30"
              className="form-control"
              placeholder="First name"
              regex="[a-z\s]{1,30}"
              onKeyUp={validateMe}
              defaultValue={_.get(data, "firstname", "")}
            />
            <small>only space and alphabetic characters are allowed</small>
          </Col>
          <Col sz={6} xl={3} lg={5} md={6} className="mb-1">
            <label className="form-label">Middle Name</label>
            <input
              type="text"
              name="middlename"
              maxlength="30"
              regex="[a-z\s]{0,30}"
              onKeyUp={validateMe}
              className="form-control"
              placeholder="Middle name"
              defaultValue={_.get(data, "middlename", "")}
            />
            <small>only space and alphabetic characters are allowed</small>
          </Col>
          <Col sz={6} xl={3} lg={12} md={6} className="mb-1">
            <label className="form-label">Last Name *</label>
            <input
              type="text"
              name="lastname"
              maxlength="30"
              required
              regex="[a-z\s]{1,30}"
              onKeyUp={validateMe}
              className="form-control"
              placeholder="Last name"
              defaultValue={_.get(data, "lastname", "")}
            />
            <small>only space and alphabetic characters are allowed</small>
          </Col>
        </Row>
        <Row>
          <Col sz={4} xl={4} lg={4} md={4} className="mb-1">
            <label className="form-label">Phone Number *</label>
            <input
              type="phone"
              name="phone"
              required
              maxlength="16"
              regex="[0-9\-]{1,16}"
              onKeyUp={validateMe}
              className="form-control"
              placeholder="Phone number"
              defaultValue={_.get(data, "phone", "")}
            />
            <small>Please enter a valid phone number upto 16 characters</small>
          </Col>
          <Col sz={4} xl={4} lg={4} md={4} className="mb-1">
            <label className="form-label">Email ID *</label>
            <input
              type="email"
              name="email"
              required
              maxlength="255"
              onKeyUp={validateMe}
              className="form-control"
              placeholder="Email Address"
              defaultValue={_.get(data, "email", "")}
            />
            <small>Please fill a valid Email Address test@test.com format only</small>
          </Col>
          <Col sz={4} xl={4} lg={4} md={4} className="mb-1">
            <label className="form-label">GDC Number</label>
            <input
              type="text"
              name="gdc"
              regex="[0-9a-zA-Z]*"
              onKeyUp={validateMe}
              className="form-control"
              placeholder="GDC Number"
              defaultValue={_.get(data, "profile.gdc", "")}
            />
            <small>Please enter alpha numberic GDC number!</small>
          </Col>
        </Row>
        <Row>
          <Col sz={4} xl={4} lg={4} md={4} className="mb-1">
            <div className="ui-front">
              <label for="dob" className="form-label">
                Date of Birth:
              </label>
              <input
                type="date"
                name="dob"
                maxlength="10"
                className="form-control"
                format="dd/mm/yyyy"
                onKeyDown={(e) => e.preventDefault()}
                min="1900-01-01"
                max="2100-12-31"
                defaultValue={_.get(data, "profile.dob", "")}
              />
            </div>
          </Col>
          <Col sz={4} xl={4} lg={4} md={4} className="mb-1">
            <div className="ui-front">
              <label for="doj" className="form-label">
                Employment Start Date:
              </label>
              <input
                type="date"
                name="doj"
                maxlength="255"
                className="form-control"
                defaultValue={_.get(data, "profile.doj", "")}
                format="dd/mm/yyyy"
                onKeyDown={(e) => e.preventDefault()}
                min="1900-01-01"
                max="2100-12-31"
              />
            </div>
          </Col>
          <Col sz={4} xl={4} lg={4} md={4} className="mb-1">
            <div className="ui-front">
              <label for="lwd" className="form-label">
                Employment Finish Date:
              </label>
              <input
                type="date"
                name="lwd"
                maxlength="255"
                className="form-control"
                defaultValue={_.get(data, "profile.lwd", "")}
                format="dd/mm/yyyy"
                onKeyDown={(e) => e.preventDefault()}
                min="1900-01-01"
                max="2100-12-31"
              />
              <small>Employment Finish Date cannot be before start date</small>
            </div>
          </Col>
        </Row>
        <Row>
          <Col sz={5} xl={5} lg={4} md={4} className="mb-1">
            <label className="form-label">Designation</label>
            <input
              type="text"
              name="designation"
              maxlength="30"
              regex="[a-z\s]{0,30}"
              onKeyUp={validateMe}
              className="form-control"
              placeholder="Designation"
              defaultValue={_.get(data, "designation", "")}
            />
            <small>only space and alphabetic characters are allowed</small>
          </Col>
          <Col sz={2} xl={2} lg={4} md={4} className="mb-1">
            <label className="form-label">Gender *</label>
            <select className="form-select" name="gender" required defaultValue={_.get(data, "profile.gender", "")}>
              {["Male", "Female", "Transgender", "Others", "Prefer not to say"].map((t) => (
                <option value={t}>{t}</option>
              ))}
            </select>
          </Col>
          <Col sz={5} xl={5} lg={4} md={4} className="mb-1">
            <label className="form-label">Pronouns</label>
            <input
              type="text"
              name="pronoun"
              maxlength="30"
              regex="[a-z\s]{0,30}"
              onKeyUp={validateMe}
              className="form-control"
              placeholder="Preferred Pronouns"
              defaultValue={_.get(data, "profile.pronoun", "")}
            />
            <small>only space and alphabetic characters are allowed</small>
          </Col>
        </Row>
        <Row>
          <Col sz={12} xl={12} lg={12} md={12} className="mb-1">
            <label className="form-label">Notes</label>
            <textarea
              name="notes"
              regex="[a-z\s]{0,10000}"
              style={{ height: "80px" }}
              onKeyUp={validateMe}
              className="form-control"
              defaultValue={_.get(data, "profile.notes", "")}
            />
            <small>only space and alphabetic characters are allowed</small>
          </Col>
        </Row>

        <h5 className="mt-4">
          <b>1st Emergency Contact</b>
        </h5>

        <Row>
          <Col sz={6} xl={3} lg={4} md={6} className="mb-1">
            <label className="form-label">Relationship</label>
            <input
              type="text"
              name="relship1"
              regex="[a-z\s]{0,300}"
              onKeyUp={validateMe}
              className="form-control"
              defaultValue={_.get(data, "profile.relship1", "")}
            />
            <small>only space and alphabetic characters are allowed</small>
          </Col>
          <Col sz={6} xl={3} lg={4} md={6} className="mb-1">
            <label className="form-label">Name</label>
            <input
              type="text"
              name="name1"
              regex="[a-z\s]{0,300}"
              onKeyUp={validateMe}
              className="form-control"
              placeholder=""
              defaultValue={_.get(data, "profile.name1", "")}
            />
            <small>only space and alphabetic characters are allowed</small>
          </Col>
          <Col sz={6} xl={3} lg={4} md={6} className="mb-1">
            <label className="form-label">Address</label>
            <input type="text" name="address1" className="form-control" defaultValue={_.get(data, "profile.address1", "")} />
          </Col>
          <Col sz={6} xl={3} lg={4} md={6} className="mb-1">
            <label className="form-label">Phone number</label>
            <input
              type="text"
              name="phone1"
              maxlength="16"
              regex="[0-9\-]{0,16}"
              onKeyUp={validateMe}
              className="form-control"
              defaultValue={_.get(data, "profile.phone1", "")}
            />
            <small>Please enter a valid phone number upto 16 characters</small>
          </Col>
        </Row>

        <h5 className="mt-4">
          <b>2nd Emergency Contact</b>
        </h5>

        <Row>
          <Col sz={6} xl={3} lg={4} md={6} className="mb-1">
            <label className="form-label">Relationship</label>
            <input
              type="text"
              name="relship2"
              regex="[a-z\s]{0,300}"
              onKeyUp={validateMe}
              className="form-control"
              defaultValue={_.get(data, "profile.relship2", "")}
            />
            <small>only space and alphabetic characters are allowed</small>
          </Col>
          <Col sz={6} xl={3} lg={4} md={6} className="mb-1">
            <label className="form-label">Name</label>
            <input
              type="text"
              name="name2"
              maxlength="30"
              regex="[a-z\s]{0,300}"
              onKeyUp={validateMe}
              className="form-control"
              defaultValue={_.get(data, "profile.name2", "")}
            />
            <small>only space and alphabetic characters are allowed</small>
          </Col>
          <Col sz={6} xl={3} lg={4} md={6} className="mb-1">
            <label className="form-label">Address</label>
            <input type="text" name="address2" className="form-control" defaultValue={_.get(data, "profile.address2", "")} />
          </Col>
          <Col sz={6} xl={3} lg={4} md={6} className="mb-1">
            <label className="form-label">Phone Number</label>
            <input
              type="text"
              name="phone2"
              maxlength="16"
              regex="[0-9\-]{0,16}"
              onKeyUp={validateMe}
              className="form-control"
              defaultValue={_.get(data, "profile.phone2", "")}
            />
            <small>Please enter a valid phone number upto 16 characters</small>
          </Col>
        </Row>

        <h5 className="mt-4">
          <b>Bank Account Details</b>
        </h5>

        <Row>
          <Col sz={6} xl={3} lg={4} md={6} className="mb-1">
            <label className="form-label">A/C Number</label>
            <input
              type="text"
              name="acnum"
              maxlength="30"
              regex="[0-9a-z]{0,30}"
              onKeyUp={validateMe}
              className="form-control"
              placeholder="A/C Number"
              defaultValue={_.get(data, "profile.acnum", "")}
            />
            <small>Please enter alphanumeric only upto 30 characters.</small>
          </Col>
          <Col sz={6} xl={3} lg={4} md={6} className="mb-1">
            <label className="form-label">SORT/IFSC Code</label>
            <input
              type="text"
              name="ifsc"
              maxlength="30"
              className="form-control"
              placeholder="SORT/IFSC Code"
              defaultValue={_.get(data, "profile.ifsc", "")}
            />
          </Col>
          <Col sz={6} xl={3} lg={4} md={6} className="mb-1">
            <label className="form-label">Bank Name</label>
            <input
              type="text"
              name="bank"
              maxlength="30"
              className="form-control"
              placeholder="Bank Name"
              defaultValue={_.get(data, "profile.bank", "")}
            />
          </Col>
          <Col sz={6} xl={3} lg={4} md={6} className="mb-1">
            <label className="form-label">Branch</label>
            <input
              type="text"
              name="branch"
              maxlength="30"
              regex="[0-9a-z\s]{0,30}"
              onKeyUp={validateMe}
              className="form-control"
              placeholder="Branch"
              defaultValue={_.get(data, "profile.branch", "")}
            />
            <small>Please enter alphanumeric only upto 30 characters.</small>
          </Col>
        </Row>

        <Row>
          <Col lg={12} className="mb-1">
            <Button type="submit" variant="primary" className="mt-2 p-3">
              Save
            </Button>
          </Col>
        </Row>
      </Form>
    );
  };

  const deleteudf = (udf) => {
    if (window.confirm(`You are going to delete upload file ${udf.udoc}, continue?`)) {
      setLoadres(parseInt(udf.udid));
      axios
        .delete(Utils.apiUrl("users/deleteudf/") + udf.id, Utils.apiHeaders())
        .then((res) => {
          setLoadres(false);
          if (res.data.success) {
            let tmp = [...udocs.userdocfiles];
            _.remove(tmp, (udf1) => parseInt(udf1.id) === parseInt(udf.id));
            setUDocs({ ...udocs, userdocfiles: tmp });
            // window.alert(res.data.message);
          } else {
            window.alert(_.isObject(res.data.message) ? Object.values(res.data.message).join(",") : res.data.message);
          }
        })
        .catch((err) => console.log(err));
    }
  };
  const getColor = (doc) => {
    const filteredData = (udocs.userdocfiles || []).filter((item) => parseInt(item.udid) === parseInt(doc.id));
    if (filteredData.length === 0) {
      return "#0d6efd"; // Vibrant blue for no doc uploaded
    }
    // Find max id for latest doc
    const maxId = Math.max(...filteredData.map((item) => parseInt(item.id)));
    const lastDoc = filteredData.find((item) => parseInt(item.id) === maxId) || filteredData[0];

    let settings = {};
    try {
      settings = typeof doc.settings === "string" && doc.settings.trim() !== "" ? JSON.parse(doc.settings) : (doc.settings || {});
    } catch(e) {
      settings = {};
    }

    if (lastDoc.exp_status == "1" && parseInt(settings.flag) !== 4 && lastDoc.expire_on) {
      return "#DC2626"; // Red for expired
    }
    if (lastDoc.doc_status == "3") {
      return "#EF4444"; // Red for disapproved
    }
    if (
      filteredData.some((d) => d.doc_status == "2" && (d.exp_status == "0" || parseInt(settings.flag) === 4 || !d.expire_on))
    ) {
      return "#F59E0B"; // Amber for pending
    }
    return "#10B981"; // Green for approved/complete
  };

  const showGapStatus = (docid) => {
    //let userDocFiles = _.filter(udocs.userdocfiles, (udf) => parseInt(udf.udid) === parseInt(docid) && moment(udf.expire_on).isAfter(moment()));
    //let gapStatus = _.get(_.maxBy(userDocFiles, 'id'), 'gap_status', 0);
    let gapStatus = _.get(_.find(udocs.udgs, g => g.udid==docid),'gap_status',0);
    const gStatus = Utils.getGapStatusList();

    return <div
      className="rounded text-white p-2 text-center"
      style={{
        width: "150px",
        backgroundColor: gStatus[gapStatus][3]
      }}
    >
      {gStatus[gapStatus][2]}
    </div>
  };

  const renderGapStatusFilters = () => {
    let uds = udocs.userdocs;
    if (dtype > 0) {
      uds = _.filter(uds, (p) => parseInt(p.cat) === parseInt(dtype));
    }

    return (
      <>
        {_.map(_.slice(Utils.getGapStatusList(), 1), (gs) => {
          let udgscol = _.filter(udocs.udgs, (udg) => parseInt(udg.gap_status) === parseInt(gs[0]));
          udgscol = _.filter(uds, (ud) => _.includes(_.map(udgscol, (u) => parseInt(u.udid)), parseInt(ud.id)));

          const isActive = parseInt(gapStatus) === parseInt(gs[0]);
          return (
            <Nav.Item className="me-1" key={gs[0]}>
              <Nav.Link
                style={{
                  backgroundColor: gs[3],
                  borderRadius: "6px",
                  padding: "6px 10px",
                  fontSize: "12px",
                  fontWeight: 600,
                  opacity: isActive ? 1 : 0.85,
                  boxShadow: isActive ? "0 0 0 2px #000, 0 2px 6px rgba(0,0,0,0.2)" : "none",
                }}
                className="text-white"
                eventKey={gs[0]}
                onClick={() => setGapStatus(parseInt(gapStatus) === parseInt(gs[0]) ? 0 : parseInt(gs[0]))}
              >
                {udgscol.length}/{uds.length}
              </Nav.Link>
            </Nav.Item>
          );
        })}
      </>
    );
  };

  const getFilteredUDocs = () => {
    let uds = _.filter(udocs.userdocs, (p) => parseInt(p.cat) === parseInt(dtype) || parseInt(dtype) === 0);
    if (parseInt(sall) === 1) {
      uds = _.filter(uds, (p) => getColor(p) === "#10B981");
    } else if (parseInt(sall) === 2) {
      uds = _.filter(uds, (p) => getColor(p) === "#F59E0B");
    } else if (parseInt(sall) === 3) {
      uds = _.filter(uds, (p) => getColor(p) === "#EF4444");
    } else if (parseInt(sall) === 4) {
      uds = _.filter(uds, (p) => getColor(p) === "#DC2626");
    }
    if (gapStatus > 0) {
      uds = _.filter(uds, (ud) => _.includes(_.map(_.filter(udocs.udgs, (u) => u.gap_status == gapStatus), (u) => parseInt(u.udid)), parseInt(ud.id)));
    }

    return uds;
  };

  const renderDocTypes = () => {
    return (
      <div className="mt-4">
        <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
          <div className="d-flex flex-wrap gap-1 align-items-center" style={{ overflowX: "auto", maxWidth: "100%" }}>
            <Nav variant="pills" className="px-0 flex-wrap gap-1" activeKey={dtype} onSelect={setDType}>
              <Nav.Item>
                <Nav.Link
                  eventKey={0}
                  onClick={() => {
                    setDType(0);
                    setGapStatus(0);
                  }}
                  style={{ borderRadius: "8px", fontSize: "12px", fontWeight: 600 }}
                >
                  All
                </Nav.Link>
              </Nav.Item>
              {_.map(udocs.doctypes, (cat, catidx) => (
                <Nav.Item key={catidx}>
                  <Nav.Link
                    eventKey={catidx}
                    onClick={() => {
                      setDType(catidx);
                      setGapStatus(0);
                    }}
                    style={{ borderRadius: "8px", fontSize: "12px", fontWeight: 600 }}
                  >
                    {cat}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
          </div>
          <div className="d-flex flex-wrap gap-1 align-items-center ms-auto" style={{ overflowX: "auto", maxWidth: "100%" }}>
            <Nav variant="pills" className="px-0 flex-wrap gap-1" activeKey={gapStatus}>
              {renderGapStatusFilters()}
            </Nav>
          </div>
        </div>
        <Card style={{ backgroundColor: "#CEDDEF88" }}>
          <Card.Body className="p-2 p-md-3">
            {/* Mobile Cards View */}
            <div className="d-block d-md-none">
              {_.map(getFilteredUDocs(), (doc, idx) => {
                let res = [];
                try {
                  res = typeof doc.resources === "string" && doc.resources.trim() !== "" ? JSON.parse(doc.resources) : (Array.isArray(doc.resources) ? doc.resources : []);
                } catch (e) {
                  res = [];
                }
                const isUpload = getColor(doc) === "#0d6efd" || getColor(doc) === "#070d59";
                return (
                  <div key={doc.id || idx} className="bg-white p-3 rounded mb-2 border shadow-sm">
                    <div className="d-flex align-items-start justify-content-between gap-2 mb-2">
                      <div className="d-flex align-items-center gap-2">
                        <span className="badge bg-primary text-white" style={{ fontSize: "11px" }}>{Utils.addZero(idx + 1)}</span>
                        <span className="fw-bold" style={{ fontSize: "13.5px", color: "var(--dt-navy)" }}>{doc.title}</span>
                      </div>
                      <img
                        src={`${process.env.PUBLIC_URL}/images/notes.png`}
                        className="clickable"
                        style={{ width: "20px", height: "20px" }}
                        title={`Notes for ${doc.title}`}
                        onClick={() => showUDNote(doc)}
                        alt="notes"
                      />
                    </div>
                    {parseInt(dtype) === 0 && (
                      <div className="mb-2">
                        <span className="badge bg-light text-secondary border" style={{ fontSize: "10.5px" }}>{udocs.doctypes[doc.cat]}</span>
                      </div>
                    )}
                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 pt-2 border-top">
                      <div>
                        {showGapStatus(doc.id)}
                      </div>
                      <div className="d-flex align-items-center gap-1">
                        {res.length > 0 && (
                          <Button size="sm" type="button" variant="outline-info" onClick={() => setResources(res)} className="rounded-pill px-2 py-0" style={{ fontSize: "11px" }}>
                            Resources
                          </Button>
                        )}
                        <Button size="sm" className="rounded-pill px-2 py-0" type="button" variant="outline-secondary" onClick={() => setTrail(doc.id)} disabled={res.length === 0} style={{ fontSize: "11px" }}>
                          Trail
                        </Button>
                        <Button
                          size="sm"
                          variant="contained"
                          className="rounded-pill px-3 py-1 fw-bold"
                          type="button"
                          style={{ backgroundColor: getColor(doc), color: "white", border: "none", fontSize: "12px" }}
                          onClick={() => setUpload(doc.id)}
                        >
                          {isUpload ? "Upload" : "Manage"}
                        </Button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Desktop Table View */}
            <div className="table-responsive d-none d-md-block">
              <Table responsive hover className="m-0 align-middle">
                <thead>
                  <tr>
                    <th className="text-end" width="50">
                      ##
                    </th>
                    <th>Document Title</th>
                    {parseInt(dtype) === 0 && <th>Category</th>}
                    <th>Resources</th>
                    <th>Action</th>
                    <th>Trail</th>
                    <th>Gap Analysis</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {_.map(getFilteredUDocs(), (doc, idx) => {
                    let res = [];
                    try {
                      res = typeof doc.resources === "string" && doc.resources.trim() !== "" ? JSON.parse(doc.resources) : (Array.isArray(doc.resources) ? doc.resources : []);
                    } catch (e) {
                      res = [];
                    }
                    return (
                      <tr key={doc.id || idx}>
                        <td className="text-end">
                          <div className="badge bg-primary text-white">{Utils.addZero(idx + 1)}</div>
                        </td>
                        <td>
                          <div className="fw-semibold text-dark" style={{ minWidth: "150px" }}>{doc.title}</div>
                        </td>
                        {parseInt(dtype) === 0 && (
                          <td>
                            <span className="badge bg-light text-secondary border">{udocs.doctypes[doc.cat]}</span>
                          </td>
                        )}
                        <td>
                          <Button size="sm" type="button" variant="primary" onClick={() => setResources(res)} disabled={res.length === 0} className="rounded-pill px-3">
                            View
                          </Button>
                        </td>
                        <td>
                          <Button
                            size="sm"
                            type="button"
                            variant="contained"
                            className="rounded-pill px-3"
                            style={{ backgroundColor: getColor(doc), color: "white", border: "none" }}
                            onClick={() => setUpload(doc.id)}
                          >
                            {getColor(doc) === "#0d6efd" || getColor(doc) === "#070d59" ? "Upload" : "Manage"}
                          </Button>
                        </td>
                        <td>
                          <Button size="sm" className="rounded-pill px-3" type="button" variant="outline-primary" onClick={() => setTrail(doc.id)} disabled={res.length === 0}>
                            Trail
                          </Button>
                        </td>
                        <td>{showGapStatus(doc.id)}</td>
                        <td>
                          <img
                            src={`${process.env.PUBLIC_URL}/images/notes.png`}
                            className="clickable"
                            style={{ width: "20px", height: "20px" }}
                            title={`Notes for ${doc.title}`}
                            onClick={() => showUDNote(doc)}
                            alt="notes"
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </Card.Body>
        </Card>
      </div>
    );
  };

  const showResources = () => {
    return (
      <Modal size="xl" aria-labelledby="contained-modal-title-vcenter" centered show={true} onHide={() => setResources(false)}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Resources</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {_.get(resources.files, "length", 0) > 0 && <h3>Documents</h3>}
          <ol>
            {_.map(resources.files, (r) => (
              <li key={r} className="py-1">
                {/* <a href={Utils.apiUrl("users/downloadud") + "/" + r}> */}
                <a target="_blank" href={Utils.viewerLink(r, `users/downloadud/${r}`)}>
                  {r}
                </a>
              </li>
            ))}
          </ol>
          {_.get(resources.links, "length", 0) > 0 && <h3>Links</h3>}
          <ol>
            {_.map(resources.links, (r) => (
              <li key={r} className="py-1">
                <a href={r} target="_blank">
                  {r}
                </a>
              </li>
            ))}
          </ol>
        </Modal.Body>
      </Modal>
    );
  };

  const showUpload = () => {
    let udf = _.filter(udocs.userdocfiles, (udfs) => parseInt(udfs.udid) === parseInt(upload));
    let ud = _.filter(udocs.userdocs, (uds) => parseInt(uds.id) === parseInt(upload));
    const selectedDoc = ud[0] || (udocs.userdocs || []).find((uds) => parseInt(uds.id) === parseInt(upload)) || {};
    let settings = {};
    try {
      settings = typeof selectedDoc?.settings === "string" && selectedDoc?.settings.trim() !== "" ? JSON.parse(selectedDoc.settings) : (selectedDoc?.settings || {});
    } catch (e) {
      settings = {};
    }

    return (
      <Modal size="xl" aria-labelledby="contained-modal-title-vcenter" centered show={true} onHide={() => !uploading && setUpload(false)}>
        <Modal.Header closeButton={!uploading}>
          <Modal.Title id="contained-modal-title-vcenter">{selectedDoc.title || "Manage Document"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table responsive={true}>
            <thead>
              <tr>
                <td>Document Name</td>
                <td>Upload On</td>
                <td>Expire On</td>
                <td>Download</td>
                <td>Delete</td>
              </tr>
            </thead>
            <tbody>
              {_.map(udf, (r) => (
                <tr key={r.id || r.furl}>
                  <td>{r.udoc}</td>
                  <td>{r.created_at}</td>
                  <td>{r.expire_on || "Never Expire"}</td>
                  <td>
                    <a target="_blank" rel="noreferrer" href={Utils.viewerLink(r.udoc, `users/downloadudf/${r.furl}`)}>
                      <img src="images/download.png" alt="download" />
                    </a>
                  </td>
                  <td>
                    <Button
                      variant="primary"
                      className="ms-2 clickable"
                      size="xs"
                      title="Delete file"
                      onClick={() => deleteudf(r)}
                      disabled={r.doc_status == 1 || r.exp_status == 1 || uploading}
                    >
                      X
                    </Button>
                  </td>
                </tr>
              ))}
              {udf.length === 0 && (
                <tr>
                  <td colSpan={5} className="text-center text-muted py-3">No previous uploads found for this document.</td>
                </tr>
              )}
            </tbody>
          </Table>

          {uploading && (
            <div className="alert alert-info py-2 px-3 mt-3 d-flex align-items-center gap-2">
              <div className="spinner-border spinner-border-sm text-primary" role="status"></div>
              <span className="fw-semibold">Uploading document, please wait...</span>
            </div>
          )}

          <Form onSubmit={uploadFile}>
            <input type="hidden" name="udid" value={upload} />
            <div className="row mt-4 d-flex align-items-end">
              <div className="col-md-4">
                <label className="form-label small fw-bold">Select File *</label>
                <input type="file" required name="udoc" className="form-control" disabled={uploading} />
              </div>
              {settings.flag == 3 && (
                <div className="col-md-4">
                  <label className="form-label small fw-bold">Expire Date (Optional)</label>
                  <input
                    type="date"
                    name="exp_date"
                    maxLength="255"
                    className="form-control"
                    disabled={uploading}
                    min={new Date(new Date().getTime() + 24 * 60 * 60 * 1000).toISOString().split("T")[0]}
                    format="dd/mm/yyyy"
                    onKeyDown={(e) => e.preventDefault()}
                    placeholder="Expire Date"
                  />
                </div>
              )}
              <div className="col-md-3 mt-2">
                <Button variant="primary" type="submit" disabled={uploading} className="d-flex align-items-center gap-2">
                  {uploading ? (
                    <>
                      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      <span>Uploading...</span>
                    </>
                  ) : (
                    "Upload"
                  )}
                </Button>
              </div>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    );
  };

  const showTrail = () => {
    let udf = _.filter(udocs.userdocfiles, (udfs) => parseInt(udfs.udid) === parseInt(trail));
    let ud = _.filter(udocs.userdocs, (uds) => parseInt(uds.id) === parseInt(trail));
    const selectedDoc = ud[0] || (udocs.userdocs || []).find((uds) => parseInt(uds.id) === parseInt(trail)) || {};

    return (
      <Modal size="xl" aria-labelledby="contained-modal-title-vcenter" centered show={true} onHide={() => setTrail(false)}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">{selectedDoc.title || "Document History"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table responsive={true}>
            <thead>
              <tr>
                <td>Name</td>
                <td>Upload On</td>
                <td>Status</td>
                <td></td>
              </tr>
            </thead>
            <tbody>
              {_.map(udf, (r) => (
                <tr key={r.id || r.furl}>
                  <td>{r.udoc}</td>
                  <td>{r.updated_at}</td>
                  <td>{showStatus(r)}</td>
                  <td>
                    <a target="_blank" rel="noreferrer" href={Utils.viewerLink(r.udoc, `users/downloadudf/${r.furl}`)}>
                      <img src="images/download.png" alt="download" />
                    </a>
                  </td>
                </tr>
              ))}
              {udf.length === 0 && (
                <tr>
                  <td colSpan={4} className="text-center text-muted py-3">No history found.</td>
                </tr>
              )}
            </tbody>
          </Table>
        </Modal.Body>
      </Modal>
    );
  };

  const docSummery = () => {
    return (
      <Row className="g-3 mb-3">
        <Col xs={6} sm={6} md={3}>
          <div
            className={`dt-card p-3 d-flex align-items-center gap-3 h-100 ${sall === 1 ? "border-success shadow-sm" : ""}`}
            style={{ cursor: "pointer", transition: "all 0.2s" }}
            title="View all Approved Documents"
            onClick={() => {
              const newStatus = sall === 1 ? 0 : 1;
              setsall(newStatus);
              profileDetails(newStatus);
            }}
          >
            <div
              className="dt-counter-badge"
              style={{
                backgroundColor: "rgba(16, 185, 129, 0.15)",
                color: "#10B981"
              }}
            >
              {_.get(udocs, "counts[0].app_count", 0)}
            </div>
            <div>
              <div className="text-muted small fw-bold text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>Approved</div>
              <div className="fw-bold" style={{ fontSize: "13px", color: "var(--dt-navy)" }}>Documents</div>
            </div>
          </div>
        </Col>
        <Col xs={6} sm={6} md={3}>
          <div
            className={`dt-card p-3 d-flex align-items-center gap-3 h-100 ${sall === 2 ? "border-warning shadow-sm" : ""}`}
            style={{ cursor: "pointer", transition: "all 0.2s" }}
            title="View all Pending Documents"
            onClick={() => {
              const newStatus = sall === 2 ? 0 : 2;
              setsall(newStatus);
              profileDetails(newStatus);
            }}
          >
            <div
              className="dt-counter-badge"
              style={{
                backgroundColor: "rgba(245, 158, 11, 0.15)",
                color: "#F59E0B"
              }}
            >
              {_.get(udocs, "counts[0].pend_count", 0)}
            </div>
            <div>
              <div className="text-muted small fw-bold text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>Pending</div>
              <div className="fw-bold" style={{ fontSize: "13px", color: "var(--dt-navy)" }}>Documents</div>
            </div>
          </div>
        </Col>
        <Col xs={6} sm={6} md={3}>
          <div
            className={`dt-card p-3 d-flex align-items-center gap-3 h-100 ${sall === 3 ? "border-danger shadow-sm" : ""}`}
            style={{ cursor: "pointer", transition: "all 0.2s" }}
            title="View all Disapproved Documents"
            onClick={() => {
              const newStatus = sall === 3 ? 0 : 3;
              setsall(newStatus);
              profileDetails(newStatus);
            }}
          >
            <div
              className="dt-counter-badge"
              style={{
                backgroundColor: "rgba(239, 68, 68, 0.15)",
                color: "#EF4444"
              }}
            >
              {_.get(udocs, "counts[0].disapp_count", 0)}
            </div>
            <div>
              <div className="text-muted small fw-bold text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>Disapproved</div>
              <div className="fw-bold" style={{ fontSize: "13px", color: "var(--dt-navy)" }}>Documents</div>
            </div>
          </div>
        </Col>
        <Col xs={6} sm={6} md={3}>
          <div
            className={`dt-card p-3 d-flex align-items-center gap-3 h-100 ${sall === 4 ? "border-danger shadow-sm" : ""}`}
            style={{ cursor: "pointer", transition: "all 0.2s" }}
            title="View all Expired Documents"
            onClick={() => {
              const newStatus = sall === 4 ? 0 : 4;
              setsall(newStatus);
              profileDetails(newStatus);
            }}
          >
            <div
              className="dt-counter-badge"
              style={{
                backgroundColor: "rgba(220, 38, 38, 0.15)",
                color: "#DC2626"
              }}
            >
              {_.get(udocs, "counts[0].expire_count", 0)}
            </div>
            <div>
              <div className="text-muted small fw-bold text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>Expired</div>
              <div className="fw-bold" style={{ fontSize: "13px", color: "var(--dt-navy)" }}>Documents</div>
            </div>
          </div>
        </Col>
      </Row>
    );
  };

  const docGapSummary = () => {
    let total = _.get(udocs.counts, '[0].total', 0);
    return (
      <Row className="row-cols-2 row-cols-sm-3 row-cols-lg-5 g-2 my-2">
        <Col>
          <div
            className={`dt-card p-3 d-flex align-items-center gap-3 h-100 ${gapStatus === 0 && dtype === 0 && sall === 0 ? "border-primary shadow-sm" : ""}`}
            style={{ cursor: "pointer", transition: "all 0.2s" }}
            title="View all documents"
            onClick={() => {
              setGapStatus(0);
              setDType(0);
              setsall(0);
              profileDetails(0);
            }}
          >
            <div
              className="dt-counter-badge"
              style={{
                backgroundColor: "#070D59",
                color: "#ffffff"
              }}
            >
              {total}
            </div>
            <div>
              <div className="text-muted small fw-bold text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>Total</div>
              <div className="fw-bold" style={{ fontSize: "13px", color: "var(--dt-navy)" }}>Documents</div>
            </div>
          </div>
        </Col>
        <Col>
          <div
            className={`dt-card p-3 d-flex align-items-center gap-3 h-100 ${gapStatus === 1 ? "border-success shadow-sm" : ""}`}
            style={{ cursor: "pointer", transition: "all 0.2s" }}
            title="View all Have this document"
            onClick={() => {
              setGapStatus(1);
              setDType(0);
              profileDetails(0);
            }}
          >
            <div
              className="dt-counter-badge"
              style={{
                backgroundColor: "#10B981",
                color: "#ffffff"
              }}
            >
              {_.size(_.filter(udocs.udgs, (gs) => gs.gap_status == 1))}
            </div>
            <div>
              <div className="text-muted small fw-bold text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>Have This</div>
              <div className="fw-bold" style={{ fontSize: "13px", color: "#10B981" }}>Verified</div>
            </div>
          </div>
        </Col>
        <Col>
          <div
            className={`dt-card p-3 d-flex align-items-center gap-3 h-100 ${gapStatus === 2 ? "border-warning shadow-sm" : ""}`}
            style={{ cursor: "pointer", transition: "all 0.2s" }}
            title="View all Working on it"
            onClick={() => {
              setGapStatus(2);
              setDType(0);
              profileDetails(0);
            }}
          >
            <div
              className="dt-counter-badge"
              style={{
                backgroundColor: "#F59E0B",
                color: "#ffffff"
              }}
            >
              {_.size(_.filter(udocs.udgs, (gs) => gs.gap_status == 2))}
            </div>
            <div>
              <div className="text-muted small fw-bold text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>In Progress</div>
              <div className="fw-bold" style={{ fontSize: "13px", color: "#F59E0B" }}>Working on it</div>
            </div>
          </div>
        </Col>
        <Col>
          <div
            className={`dt-card p-3 d-flex align-items-center gap-3 h-100 ${gapStatus === 3 ? "border-danger shadow-sm" : ""}`}
            style={{ cursor: "pointer", transition: "all 0.2s" }}
            title="View all Don't Have"
            onClick={() => {
              setGapStatus(3);
              setDType(0);
              profileDetails(0);
            }}
          >
            <div
              className="dt-counter-badge"
              style={{
                backgroundColor: "#EF4444",
                color: "#ffffff"
              }}
            >
              {_.size(_.filter(udocs.udgs, (gs) => gs.gap_status == 3))}
            </div>
            <div>
              <div className="text-muted small fw-bold text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>Missing</div>
              <div className="fw-bold" style={{ fontSize: "13px", color: "#EF4444" }}>Don't Have</div>
            </div>
          </div>
        </Col>
        <Col>
          <div
            className={`dt-card p-3 d-flex align-items-center gap-3 h-100 ${gapStatus === 4 ? "border-secondary shadow-sm" : ""}`}
            style={{ cursor: "pointer", transition: "all 0.2s" }}
            title="View all N/A"
            onClick={() => {
              setGapStatus(4);
              setDType(0);
              profileDetails(0);
            }}
          >
            <div
              className="dt-counter-badge"
              style={{
                backgroundColor: "#64748B",
                color: "#ffffff"
              }}
            >
              {_.size(_.filter(udocs.udgs, (gs) => gs.gap_status == 4))}
            </div>
            <div>
              <div className="text-muted small fw-bold text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>Exempt</div>
              <div className="fw-bold" style={{ fontSize: "13px", color: "#64748B" }}>N/A</div>
            </div>
          </div>
        </Col>
      </Row>
    );
  };

  const showNotesForUD = () => {
        return (
          <Modal size="xl" aria-labelledby="contained-modal-title-vcenter" centered show={true} onHide={() => showUDNote(false)}>
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">Notes - {udNote.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {udNote.loading === true && (
                <Alert variant="warning" className="p-3">
                  <p className="loading-msg">Fetching User Document Note..</p>
                  <ProgressBar variant="warning" animated now={100} />
                </Alert>
              )}
              {udNote.loading === false && (
                <div style={{ maxHeight: "400px", overflow: "auto" }}>
                  {_.get(notes, "length", 0) === 0 && (
                    <Alert variant="danger" className="p-3">
                      <p className="loading-msg">No notes found!</p>
                    </Alert>
                  )}
                  {_.map(notes, (note) => (
                    <div key={note.id} className="d-flex mt-1 py-2 border-bottom">
                      <div>
                        <div className="badge bg-light text-dark">{Utils.toLocal(note.created_at).format("HH:mm MMM DD, YY")}</div>
                      </div>
                      <div className="text-start text-dark flex-grow-1">{note.note}</div>
                      
                    </div>
                  ))}
                </div>
              )}
            </Modal.Body>
          </Modal>
        );
      };

  return (
    <div className="mt-4">
      {loading && (
        <Alert variant="info" className="p-3">
          <p className="loading-msg">Fetching details..</p>
          <ProgressBar variant="info" animated now={100} />
        </Alert>
      )}
      {!loading && (
        <>
          <h2 className="my-3">
            <b>My Profile</b>
          </h2>
          {docSummery()}
          <Card border="light" className="shadow mt-5 dashboardStats">
            <Card.Body className="mx-3">
              {showprof && (
                <div>
                  <h4 className="mb-3">
                    <b>Personal Details</b>
                  </h4>
                  <Card style={{ backgroundColor: "#CEDDEF88" }}>
                    <Card.Body className="m-2">{renderForm()}</Card.Body>
                  </Card>
                </div>
              )}

              {docGapSummary()}

              {renderDocTypes()}
            </Card.Body>
          </Card>

          {(_.get(resources.files, "length", 0) > 0 || _.get(resources.links, "length", 0) > 0) && showResources()}
          {upload && showUpload()}
          {trail && showTrail()}
          {udNote !== false && showNotesForUD()}
        </>
      )}
    </div>
  );
};

export default MyProfile;
